import { RefObject, useEffect, useRef } from 'react';

export const useSaveScroll = (
  containerRef: RefObject<HTMLElement>,
  nameForSaveScroll?: string,
  isNeedRemoveOnReboot?: boolean
) => {
  const scrollPositionRef = useRef(0);

  useEffect(() => {
    if (!nameForSaveScroll || !containerRef.current) return;

    const handleBeforeUnload = () => {
      if (isNeedRemoveOnReboot) {
        sessionStorage.removeItem(nameForSaveScroll);
      }
    };

    const savedY = sessionStorage.getItem(nameForSaveScroll);
    if (savedY) {
      containerRef.current.scrollTop = +savedY;
      scrollPositionRef.current = +savedY;
    }

    const handleScroll = () => {
      if (containerRef.current) {
        scrollPositionRef.current = containerRef.current.scrollTop;
      }
    };

    const container = containerRef.current;
    container.addEventListener('scroll', handleScroll);
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      sessionStorage.setItem(nameForSaveScroll, scrollPositionRef.current.toString());
      container.removeEventListener('scroll', handleScroll);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [nameForSaveScroll, containerRef]);
};
